import { Card, CardContent, Typography } from "@altimateai/lego";
import { Stack } from "@altimateai/lego";
import NoDbtColabFoundSvg from "@/assets/images/no_dbt_colab_found.svg";

export const DbtDocsEmptySharesList = () => (
  <Card>
    <CardContent className="al-pt-4">
      <Stack justify="center">
        <Stack justify="center" align="center" className="al-p-4" direction="column">
          <img src={NoDbtColabFoundSvg} alt="No collaboration found" />
          <Typography variant="h2" className="al-mt-4 al-mb-4 al-text-black">
            No Colab Found
          </Typography>
          <Typography className="al-text-black">
            No dbt Documentation has been shared yet.
          </Typography>
        </Stack>
      </Stack>
    </CardContent>
  </Card>
);
